import React from "react";

export default function MarqueeBanner({ stats }) {
  const peers = stats?.peers_online?.toLocaleString() || "248,392";
  const files = stats?.shared_files?.toLocaleString() || "4,923,348";
  const ping = stats?.ping_ms ?? 64;

  const announcement = [
    `⚡ ${peers} TRUSTED PEERS ONLINE`,
    `${files} verified MP3s in the swarm`,
    `LemonShield™ v4.2 ACTIVE — 0 viruses detected this week`,
    `NEW! "Get LemonWire Pro" for ad-free P2P (it's still free)`,
    `Ping to swarm: ${ping}ms`,
    `REMEMBER: Defrag your hard drive!`,
    `Sign our Guestbook — we have cookies 🍪`,
    `NO MALWARE. JUST BANGERS.`,
  ].join("   ★   ");

  return (
    <div
      data-testid="marquee-banner"
      className="flex items-center bevel-in"
      style={{
        background: "linear-gradient(to bottom, #0A0A0A, #1A1A1A)",
        height: 32,
      }}
    >
      <div
        className="px-2 h-full flex items-center text-[13px] font-bold whitespace-nowrap shrink-0"
        style={{
          background: "linear-gradient(to bottom, #E81123 0%, #8B0A14 100%)",
          color: "#FFEB3B",
          textShadow: "1px 1px 1px rgba(0,0,0,0.6)",
          borderRight: "2px solid #5B0207",
        }}
      >
        <span className="blink mr-1">●</span> LIVE NEWS
      </div>
      <div className="marquee-outer flex-1 h-full flex items-center">
        <div
          className="marquee-inner marquee-slow text-[15px]"
          style={{
            fontFamily: '"Share Tech Mono", monospace',
            color: "#FFEB3B",
            textShadow: "0 0 3px #FFEB3B, 0 0 6px rgba(255,235,59,0.4)",
          }}
        >
          {announcement} &nbsp;&nbsp;&nbsp;★&nbsp;&nbsp;&nbsp; {announcement} &nbsp;&nbsp;&nbsp;
        </div>
      </div>
    </div>
  );
}
